import { Chacra } from '../models';

function formatValue(type: string, value: any): string {
  let result = '-';
  if (value) {
    switch (type) {
      case 'float':
        result = parseFloat(value).toFixed(2);
        break;
      case 'integer':
        result = parseInt(value, 2).toString();
        break;
      default:
        result = value.toString();
    }
  }
  return result;
}

export function chacraPopupHTML(chacra: Chacra) {
  let linkAttached = `-`;
  // const adjunto = chacra.adjunto;
  // if (adjunto) {
  //   linkAttached = `<a href="${adjunto.adjuntoURL}" target="_blank" class="page-link" style="color: #04488e">
  //                       ${adjunto.adjuntoNombre}.${adjunto.adjuntoExtension}
  //                   </a>`;
  // }

  let terrazaHtml = '';
  // if (chacra.terraza) {
  //   terrazaHtml = `
  //     <div>
  //       <h2>Terraza</h2>
  //       <table class="popup-template-table">
  //       <tr>
  //         <th>Identificacion de la terraza</th>
  //         <td>${formatValue('string', chacra.terraza.terrazaId)}</td>
  //       </tr>
  //       <tr>
  //         <th>Área de cuenca evacuada (ha)</th>
  //         <td>${formatValue('string', chacra.terraza.terrazaAreaCuencaExcavada)}</td>
  //       </tr>
  //       <tr>
  //         <th>Largo de la terraza (m)</th>
  //         <td>${formatValue('float', chacra.terraza.terrazaCanalLargo)}</td>
  //       </tr>
  //       <tr>
  //         <th>Caudal pico de escurrimiento a la salida de la terraza (m3/s)</th>
  //         <td>${formatValue('float', chacra.terraza.terrazaCanalCaudalPicoEscurrimiento)}</td>
  //       </tr>
  //       </table>
  //     </div>
  //   `;
  // }
  //
  let e = '';
  // if (chacra.errors && chacra.errors.length > 0) {
  //   e = '<div class="error-list"> Errores';
  //   for (const ee of chacra.errors) {
  //     e += `<div class="error-bubble small"><div class="msg"><span>${ee.description}</span></div></div>`;
  //   }
  //   e += '</div>';
  // }
  let w = '';
  // if (chacra.warnings && chacra.warnings.length > 0) {
  //   w = '<div class="error-list"> Advertencias';
  //   for (const ww of chacra.warnings) {
  //     w += `<div class="error-bubble warn small"><div class="msg"><span>${ww.observacionJustificacion}</span></div></div>`;
  //   }
  //   w += '</div>';
  // }

  let suelos = 'Obteniendo suelos…';
  if (!chacra.suelosLoading) {
    if (chacra.suelos.length > 0) {
      suelos = `<table class="popup-template-table">
  <tr>
    <th>Descripción</th>
    <td>${formatValue('string', chacra.chacraSueloAsignadoDsc)}</td>
  </tr>
  <tr>
    <th>K</th>
    <td>${formatValue('float', chacra.chacraSueloAsignadoFactorK)}</td>
  </tr>
  <tr>
    <th>T</th>
    <td>${formatValue('float', chacra.chacraSueloAsignadoTolerancia)}</td>
  </tr>
  <tr>
    <th>Informe</th>
    <td>
        ${linkAttached}
    </td>
  </tr>
  </table>`;
    } else {
      suelos = `<button type="button"
      class="esri-editor__control-button esri-button"
      onclick="
      window.dispatchEvent(new CustomEvent('chacraPopupClick',{detail:'`+ chacra.rendimientoId + `'}))">
        Obtener Suelos</button>`;
    }
  }

  return `
  <div class="chacra-popup-map">
    ${e}
    ${w}
    <div>
      <h2>Administrativo</h2>
      <table>
        <tr><th>Área (ha)</th><td>${formatValue('float', chacra.chacraArea)}
        </td></tr>
        <tr><th>DICOSE</th><td>${formatValue('string', chacra.chacraDicose)}</td></tr>
      </table>
    </div>
    <div>
      <h2>Padrones</h2>
      <table class="popup-template-table">
        <tr>
          <th>Departamento</th>
          <th>Número</th>
          <th>Área (ha)</th>
        </tr>
      ${chacra.padrones.filter(p => p.padronFueSeleccionado).map(p =>
    `<tr>
          <td>${formatValue('string', p.departamentoNombre)}</td>
          <td>${formatValue('string', p.padronId)}</td>
          <td>${formatValue('float', p.padronArea)}</td>
        </tr>`).reduce((c1: string, a: string) => (a += c1), '')}
      </table>
    </div>
    <div>
      <h2>Suelo</h2>
      ${suelos}
    </div>
    <div>
      <h2>Factores Limitantes</h2>
      <table class="popup-template-table">
      <tr><th></th><th>Elegido</th><th>Sugerido</th></tr>
      <tr>
        <th>A</th>
        <td>${formatValue('float', chacra.chacraFactorAAsignado)}</td>
        <td>${formatValue('float', chacra.chacraFactorALimitante)}</td>
      </tr>
      <tr>
        <th>R</th>
        <td>${formatValue('float', chacra.chacraFactorRAsignado)}</td>
        <td>${formatValue('float', chacra.chacraFactorRAutomatico)}</td>
      </tr>
      <tr>
        <th>K</th>
        <td>${formatValue('float', chacra.chacraSueloAsignadoFactorK)}</td>
        <td>${formatValue('float', chacra.chacraSueloLimitanteFactorK)}</td>
      </tr>
      <tr>
        <th>LS</th>
        <td>${formatValue('float', chacra.chacraFactorLSAsignado)}</td>
        <td>${formatValue('float', chacra.chacraFactorLSLimitante)}</td>
      </tr>
      <tr>
        <th>L</th>
        <td>${formatValue('float', chacra.chacraFactorLAsignado)}</td>
        <td>${formatValue('float', chacra.chacraFactorLLimitante)}</td>
      </tr>
      <tr>
        <th>S</th>
        <td>${formatValue('float', chacra.chacraFactorSAsignado)}</td>
        <td>${formatValue('float', chacra.chacraFactorSLimitante)}</td></tr>
      <tr>
        <th>Largo (m)</th>
        <td>${formatValue('float', chacra.chacraLargoAsignado)}</td>
        <td>${formatValue('float', chacra.chacraLargoLimitante)}</td>
      </tr>
      <tr>
        <th>Pendiente (%)</th>
        <td>${formatValue('float', chacra.chacraPendienteAsignado * 100)}</td>
        <td>${formatValue('float', chacra.chacraPendienteLimitante * 100)}</td>
      </tr>
            <tr>
            <th>P</th><td>${formatValue('float', chacra.chacraFactorP)}
            </td><td></td>
            </tr>
      <tr>
      <th>C</th><td>${formatValue('float', chacra.chacraFactorC)}
      </td><td></td>
      </tr>
      </table>
    </div>
    ${terrazaHtml}
  </div>
  `;
}

